import { STORAGE_API_BASE } from "@/utils/constant";
import { getAccessToken } from "./tokenManager";

// Build the Authorization header from the override or the stored access token.
function getAuthToken(overrideToken?: string): string | undefined {
  if (overrideToken) {
    return overrideToken.startsWith("Bearer ") ? overrideToken : `Bearer ${overrideToken}`;
  }

  if (typeof window !== "undefined") {
    const token = getAccessToken();
    return token ? `Bearer ${token}` : undefined;
  }

  return undefined;
}

// POST /api/media/playlist => body: { payload: string }

interface ProcessPlaylistResponse {
  data: string;
  success: boolean;
  message: string;
  error: unknown;
}

export const getPlaylist = async (payload: string): Promise<ProcessPlaylistResponse> => {
  const headers: HeadersInit = { "Content-Type": "application/json" };
  const authToken = getAuthToken();
  if (authToken) {
    headers["Authorization"] = authToken;
  }

  const res = await fetch(`${STORAGE_API_BASE}/media/playlist`, {
    method: "POST",
    body: JSON.stringify({ payload }),
    headers,
  });
  if (!res.ok) throw new Error(`get playlist failed (${res.status})`);
  const data = await res.json();
  if (!data?.success) throw new Error("get playlist invalid response");
  return data;
};
